import { createCustomMessage } from '../Utils/messageUtils'

const DefaultMessageStrategy = {
  execute: (messageData) => {
    if (!messageData?.welcomeMessage) {
      return [
        createCustomMessage("", 'CustomWelcomeMessageBot', { payload: { text: "Ops, agora estou com problemas. Tente falar comigo mais tarde. 😁" } })
      ]
    }

    return [
      createCustomMessage("", 'CustomWelcomeMessageBot', { payload: { text: messageData.welcomeMessage } }),
      createCustomMessage("", 'CustomMessageBot', { payload: { text: messageData.newFaqAnswer } })
    ]
  }
}

export default DefaultMessageStrategy